import { env } from "@/config/env";
import { setCookie } from "cookies-next";

export const getAccessToken = () => {
  const booking = getSharingCookie("booking");
  if (!booking) {
    return null;
  }
  // setCookie("token", `bearer ${booking?.data?.access_token}`);
  return booking?.data?.access_token;
};

export const getSharingCookie = (key: string) => {
  if (!process.browser) {
    return;
  }
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  if (cookies) {
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === "booking") {
        const ssoData = JSON.parse(cookieValue);
        return ssoData;
      }
    }
  }
  return null;
};

export const setMultiCookie = (ssoData: any, options?: { req?: any; res?: any }) => {
  document.cookie = `sso_token=${JSON.stringify(ssoData?.token)}; domain=${
    env.DOMAIN_TO_SHARE_COOKIE
  }; path=/;`;
  const data = ssoData?.data;
  if (!data?.food) return;
  document.cookie = `food=${JSON.stringify(data?.food)}; domain=${
    env.DOMAIN_TO_SHARE_COOKIE
  }; path=/;`;
  if (!data?.booking) return;
  document.cookie = `booking=${JSON.stringify(data?.booking)}; domain=${
    env.DOMAIN_TO_SHARE_COOKIE
  }; path=/;`;
  document.cookie = `booking=${JSON.stringify(data?.booking)}; domain=${
    env.DOMAIN_TO_SHARE_COOKIE
  }; path=/;`;
  if (!data?.link) return;
  document.cookie = `link=${JSON.stringify(data?.link)}; domain=${
    env.DOMAIN_TO_SHARE_COOKIE
  }; path=/;`;
  if (!data?.new_chat) return;
  document.cookie = `new_chat=${JSON.stringify(data?.new_chat)}; domain=${
    env.DOMAIN_TO_SHARE_COOKIE
  }; path=/;`;
};

export const clearMultiCookie = () => {
  document.cookie = `sso_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${env.DOMAIN_TO_SHARE_COOKIE}; path=/;`;
  document.cookie = `food=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${env.DOMAIN_TO_SHARE_COOKIE}; path=/;`;
  document.cookie = `booking=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${env.DOMAIN_TO_SHARE_COOKIE}; path=/;`;
  document.cookie = `link=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${env.DOMAIN_TO_SHARE_COOKIE}; path=/;`;
  document.cookie = `new_chat=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${env.DOMAIN_TO_SHARE_COOKIE}; path=/;`;
};
